import { isImmutable } from './isImmutable'
import { isEmpty } from './isEmpty'

export function isTruthy(val: any) {
	if (typeof val === 'boolean' && !val) {
		return false
	}
	if (isEmpty(val)) {
		return false
	}
	if (isImmutable(val)) {
		if (isEmpty(val.toJS())) {
			return false
		}
	}
	return true
}
